import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import "./Menu.scss"

const Menu = () => {
    const dropdown = useRef();
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        {id: '/', title: 'Календарь записей'},
        {id: '/schedule/', title: 'График специалистов'},
        {id: '/deals/', title: 'Сделки'},
        {id: '/clients/', title: 'Клиенты'},
        {id: '/production/', title: 'Производство'},
        {id: '/analitics/', title: 'Аналитика'},
        {id: '/company/', title: 'Компания'},
        {id: '/settings/', title: 'Настройки'},
    ];

    const [selected, setSelected] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const currentPath = location.pathname;

        let activeItem;

        for (let i = 1; i < menuItems.length; i++) {
            if (currentPath.includes(menuItems[i].id)) {
                activeItem = menuItems[i];
            }
        }

        if (!activeItem) {
            activeItem = menuItems[0];
        }

        setSelected(activeItem);
    }, [location.pathname]);

    useEffect(() => {
        const timer = setTimeout(() => {
            document.addEventListener('click', documentClickHandlerDropdown);
        }, 0);

        return () => {
            document.removeEventListener('click', documentClickHandlerDropdown);
            clearTimeout(timer);
        };
    }, []);

    const documentClickHandlerDropdown = (e) => {
        if (!dropdown.current || !dropdown.current.contains(e.target)) {
            setOpen(false);
        }
    };

    const handleItemClick = (item) => {
        setSelected(item);
        setOpen(false);
    };

    return (
        <>
            {menuItems && (
                <div className={"menu" + (open ? " open" : "")} ref={dropdown}>
                    <div className="menu__btn" onClick={() => setOpen(!open)}>
                        {selected ? selected.title : 'Выберите раздел'}
                    </div>
                    <div className="menu__list g-hide-scrollbar">
                        {menuItems.map((item) => (
                            <Link
                                className={"menu__list-item" + (selected?.id === item.id ? " selected" : "")}
                                key={item.id}
                                to={item.id}
                                onClick={() => handleItemClick(item)}
                            >
                                <div className="menu__list-item-inner">
                                    {item.title}
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default Menu;